module.exports = __webpack_public_path__ + "static/media/CantenWelcome.53faa471.png";